
export const CacheService = Object.freeze({
  set(key, value, expirationMinutes = 60) {
    const expires = Date.now() + expirationMinutes * 60 * 1000;
    localStorage.setItem(key, JSON.stringify({ value, expires }));
  },

  get(key) {
    const cached = JSON.parse(localStorage.getItem(key) || 'null');
    if (!cached) return null;
    if (Date.now() > cached.expires) {
      localStorage.removeItem(key);
      return null;
    }
    return cached.value;
  },

  remove(key) {
    localStorage.removeItem(key);
  },

  clear(keys) {
    keys.forEach(key => localStorage.removeItem(key));
  },
});
